import { useState, useEffect } from 'react';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { ArrowLeft, Play, Lock, ChevronRight } from 'lucide-react';
import BottomBar from '../../components/layout/BottomBar';
import { supabase } from '../../supabaseClient';

const QuestOverview = () => {
  const [, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { questId } = useParams();
  const [subQuests, setSubQuests] = useState([]);

  useEffect(() => {
    const checkUser = async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) {
        navigate('/login');
      } else {
        setUser(user);
        setLoading(false);

        const updatedSubQuests = [
          { id: 1, title: 'Sub Quest 1 - 10XP', duration: '04:30 remaining', unlocked: true },
          { id: 2, title: 'Sub Quest 2 - 20XP', duration: '02:00 remaining', unlocked: true },
          { id: 3, title: 'Sub Quest 3 - 5XP', duration: '07:30 remaining', unlocked: false },
        ];

        setSubQuests(updatedSubQuests);
      }
    };

    checkUser();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center font-sans">
        Loading...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col pb-24">
      {/* Header */}
      <div className="bg-primary h-20 flex items-center justify-between px-6">
        <Link to="/dashboard">
          <ArrowLeft className="w-6 h-6 text-white" />
        </Link>
        <h1 className="text-white text-3xl font-sans">PenguinQuest</h1>
        <div className="w-9 h-7" /> {/* Placeholder to balance layout */}
      </div>

      {/* Quest Overview */}
      <div className="text-center py-4">
        <h2 className="text-black text-lg font-sans font-medium">
          Quest {questId} Overview
        </h2>
      </div>

      {/* Quest Image */}
      <div className="px-4 mb-6">
        <div className="relative">
          <div
            className="w-full h-52 bg-cover bg-center rounded"
            style={{
              backgroundImage:
                "url('https://tknzgegeniiojzsascfl.supabase.co/storage/v1/object/public/pictures//resized%20lions%20head.png')",
            }}
          ></div>
        </div>
      </div>

      {/* Quest Title & Info */}
      <div className="px-5">
        <h3 className="text-black text-xl font-sans font-medium mb-2">
          Embark on your mission
        </h3>
        <p className="text-black/55 text-sm font-sans mb-6">
          Time remaining: 2H 30min
        </p>
      </div>

      {/* Tabs */}
      <div className="px-5 mb-6">
        <div className="flex space-x-8">
          <button className="text-black text-sm font-sans border-b-2 border-black pb-1">
            SubQuests
          </button>
          <button className="text-black/40 text-sm font-sans">Description</button>
        </div>
      </div>

      {/* SubQuests */}
      <div className="px-4 space-y-4 mb-8">
        {subQuests.map((subquest) => (
          <Link
            key={subquest.id}
            to={
              subquest.unlocked
                ? `/quest/${questId}/subquest/${subquest.id}`
                : '#'
            }
            className="block pointer-events-auto"
            style={{ pointerEvents: subquest.unlocked ? 'auto' : 'none' }}
          >
            <div className="flex items-center space-x-4">
              <div className="w-11 h-11 rounded-full bg-blue-500 flex items-center justify-center">
                {subquest.unlocked ? (
                  <Play className="w-6 h-6 text-white fill-current" />
                ) : (
                  <Lock className="w-5 h-5 text-white" />
                )}
              </div>
              <div className="flex-1">
                <h4 className="text-black text-sm font-sans">{subquest.title}</h4>
                <p className="text-black/30 text-xs font-sans">{subquest.duration}</p>
              </div>
              <ChevronRight className="w-4 h-4 text-black" />
            </div>
          </Link>
        ))}
      </div>

      {/* Take Quiz Button */}
      <div className="px-6 mb-8">
        <Link to="/quiz1">
          <button className="w-full bg-black text-white font-sans text-xl py-3 rounded-[31px] hover:bg-neutral-800 transition-colors">
            Take Quiz
          </button>
        </Link>
      </div>

      {/* Bottom Navigation Bar */}
      <BottomBar />
    </div>
  );
};

export default QuestOverview;
